import { render, staticRenderFns } from "./NewPhyCollectionDialog.vue?vue&type=template&id=186d741a&scoped=true"
import script from "./NewPhyCollectionDialog.vue?vue&type=script&lang=js"
export * from "./NewPhyCollectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186d741a",
  null
  
)

export default component.exports